import { ImportNfeResponse, NfeAnalysisResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/nfe` — ler um XML de NF-e de entrada e transformá-lo em compra.
 *
 * Duas chamadas: `analyzeNfe` diz o que o arquivo contém e o que já existe no
 * catálogo; `importNfe` grava. A análise não escreve nada.
 */
// Two calls, and the split is the feature: `analyze` says what would happen and
// writes nothing, `import` does it. The bytes are sent twice on purpose — what
// gets imported is computed from the file in front of the operator, not from a
// copy the server was holding.
export const analyzeNfe = async (file, signal) => {
    const form = new FormData();
    form.append('file', file);
    return NfeAnalysisResponse.parse(await request('/api/v1/purchasing/nfe/analyze', {
        method: 'POST',
        body: form,
        ...(signal ? { signal } : {}),
    }));
};
export const importNfe = async (file, decisions, branchId) => {
    const form = new FormData();
    // Fields before the file: they are read off the upload, and putting them
    // first means they are parsed whatever the server does with the stream.
    form.append('decisions', JSON.stringify(decisions));
    if (branchId !== undefined)
        form.append('branchId', branchId);
    form.append('file', file);
    return ImportNfeResponse.parse(await request('/api/v1/purchasing/nfe/import', {
        method: 'POST',
        body: form,
    }));
};
//# sourceMappingURL=nfe.js.map